module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sekundaerlogo_postale_neg.a1f146eb.png";